import * as gzGo from './go.service';

export default angular.module('gazelle.components.go', [
  'ui.router',
  'rhino.core.http',
  'rhino.components.application',
  'rhino.components.sessionStorage',
  'gazelle.components.appBroker',
  'gazelle.components.l10n',
])
  .service(gzGo.name, gzGo.default)
  .name;




// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/go/go.module.js